(function () {
  'use strict';

  var CONFIG       = null;
  var currentTitle = null;
  var debounce     = null;

  /* ── 1. Load config ── */
  function loadConfig() {
    var el = document.getElementById('vg-variant-map');
    if (!el) return false;
    try { CONFIG = JSON.parse(el.textContent); return true; }
    catch (e) { console.error('[vg] config parse error', e); return false; }
  }

  /* ── 2. Show the correct row ── */
 /* ── 2. Show the correct row ── */
function showRow(variantTitle) {
  if (variantTitle === currentTitle) return;
  currentTitle = variantTitle;

  // Swap active class instead of toggling display
  Object.values(CONFIG.rows).forEach(function (rowId) {
    var el = document.getElementById(rowId);
    if (el) el.classList.remove('vg-row--active');
  });

  var targetId = CONFIG.rows[variantTitle];
  if (targetId) {
    var target = document.getElementById(targetId);
    if (target) target.classList.add('vg-row--active');
  }
}

  /* ── 3. Cart: add gifts for variant, remove others ── */
  async function syncCart(variantTitle) {
    var shouldHave = CONFIG.giftVariantIds[variantTitle] || [];
    var allGiftIds = [];
    Object.values(CONFIG.giftVariantIds).forEach(function (ids) {
      ids.forEach(function (id) {
        if (!allGiftIds.includes(id)) allGiftIds.push(id);
      });
    });

    try {
      var cart     = await fetch('/cart.js').then(r => r.json());
      var inCart   = cart.items.map(function (i) { return i.variant_id; });

      // Remove gifts that don't belong
      var toRemove = allGiftIds.filter(function (id) {
        return inCart.includes(id) && !shouldHave.includes(id);
      });
      if (toRemove.length) {
        var updates = {};
        toRemove.forEach(function (id) { updates[id] = 0; });
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ updates: updates })
        });
      }

      // Add gifts that should be there
      var toAdd = shouldHave.filter(function (id) { return !inCart.includes(id); });
      for (var i = 0; i < toAdd.length; i++) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ id: toAdd[i], quantity: 1 })
        });
      }

      // Refresh Shrine cart drawer
      document.dispatchEvent(new CustomEvent('cart:refresh'));

    } catch (e) {
      console.warn('[vg] cart sync error', e);
    }
  }

  /* ── 4. Resolve variant ID → title ── */
  function titleFromId(variantId) {
    var match = CONFIG.productVariants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    return match ? match.title : null;
  }

  /* ── 5. Get selected variant ID from the form ── */
  function getSelectedId() {
    var inp = document.querySelector(
      'form[action="/cart/add"] input[name="id"], .product-form input[name="id"]'
    );
    return inp ? inp.value : null;
  }

  /* ── 6. Handle any variant change ── */
  function onVariantChange() {
    clearTimeout(debounce);
    debounce = setTimeout(function () {
      var id    = getSelectedId();
      var title = id ? titleFromId(id) : null;
      console.log('[vg] variant changed → id:', id, '→ title:', title);
      if (!title) return;
      showRow(title);
      syncCart(title);
    }, 80);
  }

  /* ── 7. Wire up all listeners ── */
  function initListeners() {
    // Shrine's native event (most reliable)
    document.addEventListener('variant:change', function (e) {
      var title = e.detail && e.detail.variant && e.detail.variant.title;
      if (title) { showRow(title); syncCart(title); }
    });

    // Watch hidden input mutation (Shrine updates this on variant change)
    var form = document.querySelector('form[action="/cart/add"], .product-form');
    if (form) {
      var inp = form.querySelector('input[name="id"]');
      if (inp) {
        new MutationObserver(onVariantChange).observe(inp, { attributes: true });
      }
      form.addEventListener('change', onVariantChange);
    }

    // Radio/pill pickers
    document.querySelectorAll(
      '[data-option-position] input[type="radio"], .variant-picker input[type="radio"]'
    ).forEach(function (r) { r.addEventListener('change', onVariantChange); });
  }

  /* ── 8. Set initial state on page load ── */
  function setInitial() {
    var id    = getSelectedId();
    var title = id ? titleFromId(id) : null;
    if (title) showRow(title);
    // Don't auto-add to cart on page load — only on user interaction
  }

  /* ── Bootstrap ── */
  function init() {
    if (!loadConfig()) return;
    setInitial();
    initListeners();
    console.log('[vg] ✓ ready');
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();